/* Used in Facebook component */
export class FacebookCampaign {
  _id: string;
  title: string;
  spend: number;
  value: number;
}
